import angular from 'angular'

import VdSelectInput from './vd-select-input.directive'

angular.module('vend.ui').directive('vdSelectInput', VdSelectInput)
